var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CustomScenarioChart',{attrs:{"period":_vm.customChartPeriod,"category":"age"}}),_c('ConsiderVoluntaryPayments'),_c('ScheduleRMPayments'),_c('InterestRateScenarioAndPVARate'),_c('ImportantData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }